import React from "react";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import queryString from "query-string";

import { getListOfSubcategoriesforFolderUploadQuery, getSubcategoryListQuery, removeSubcategory } from "../../../services/graphql/queries/category-management";

import ReactModal from "../../Common/ReactModal";
import DisplayErrors from "../../Common/DisplayErrors";

import { SET_TIMEOUT_VALUE } from "../../../constants/app-constants";

import { errorMessage } from "../../../miscellaneous/error-messages";
import { errorMsg } from "../../../miscellaneous/react-toastify";

import BreadCrumb from "./SubCategoryBreadCrumb"

class SubcategoryList extends React.Component {
    constructor(props){
        super(props)
        this.state = {
            loading:false,
            errors:[],
            subcategories:[],
            deleteId:'',
            reactModalVisible: false,
            requireCancel: false,
            modalMessage: "",
            requireCancel:true
        }
        this.submitModal = this.submitModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onBreadCrumbClick = this.onBreadCrumbClick.bind(this);
    }

    submitModal() {
        this.props.client
            .mutate({
                mutation: removeSubcategory,
                variables: {
                    id: this.state.deleteId
                },
                fetchPolicy: "no-cache"
            })
            .then(result => {
                this.setState({ reactModalVisible: false });
                this.getListOfSubcategory();
            })
            .catch(error => {
                console.log("~~~error: ", error);
                this.setState({ loading: false, errors: [errorMessage(error)] });
                this.timer = setTimeout(() => {
                this.setState({ errors: [] });
                }, SET_TIMEOUT_VALUE);
            });
    }
    
    closeModal(){
        this.setState({ reactModalVisible: false, deleteId: ''});
    }

    onRemoveSubcategory(id){
        this.setState({ reactModalVisible: true, modalMessage:"Are you sure, you want to delete this folder?", deleteId: id });
        
    }

    getListOfSubcategory(){        
        this.setState({ loading: true });
        let subcategoryLevel = 2;
        if(this.props.breadCrumbArr.length){
            subcategoryLevel = this.props.breadCrumbArr.length + 1;
        }
        this.props.client
        .query({
            query: getListOfSubcategoriesforFolderUploadQuery,
            variables: {
                referenceId: this.props.category.id,
                categoryId: parseInt(queryString.parse(this.props.location.search).id),
                subcategoryLevel: subcategoryLevel
            },
            fetchPolicy: "network-only"
        })
        .then(result => {
            var subcategories = result.data.getListOfSubcategoriesforFolderUpload;

            this.initialState = {
                subcategories: subcategories
            };
            this.setState({ ...this.initialState, loading: false, error: "" });
        })
        .catch(error => {
            let message = errorMessage(error);
            errorMsg(message[0]);
            this.setState({ loading: false, error: error.message });
        });
    }

    onEditSubcategory(data){
        this.props.onEditSubcategory(data);
    }

    onUpdateSubcategory(subcategory){
        this.props.onUpdateSubcategory(subcategory)
    }

    onBreadCrumbClick(data, index){
        this.props.onRemoveBreadCrumb(data, index)
    }

    componentDidMount(){
        this.getListOfSubcategory();
    }

    componentDidUpdate(prevProps){
        if(prevProps.category !== this.props.category){
            this.getListOfSubcategory();
        }
    }

    render() {
        const { loading, errors, subcategories, reactModalVisible, requireCancel,   modalMessage, } = this.state;
        const { category, breadCrumbArr } = this.props;
        return (
            <div className="p-t-0" id="showlistDiv">
                <ReactModal
                    reactModalVisible={reactModalVisible}
                    submitModal={this.submitModal}
                    modalMessage={modalMessage}
                    requireCancel={requireCancel}
                    closeModal={this.closeModal}
                />
                <div className="row align-items-center">
                    <div className="col-md-10">
                        <h1 className="heading m-b-0">
                        Folder List 
                        </h1>
                        <div
                            className="row"
                            style={{
                                display: errors.length === 0 ? "none" : "block"
                            }}
                            >
                            <div className="col-md-6">
                                <div className="alert alert-success" role="alert">
                                <div className="row">
                                    <span className="danger-link">
                                    <DisplayErrors errors={errors} />
                                    </span>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <BreadCrumb data={breadCrumbArr} onBreadCrumbClick={this.onBreadCrumbClick}/>
                <div className="table-responsive" style={{maxHeight: '52vh'}}>
                    <table className="table table-style-1 ">
                        <thead>
                            <tr>
                                <th scope="col" width={400}>
                                ID
                                </th>
                                <th scope="col" width={400}>
                                FOLDER / SUB - FOLDER NAME
                                </th>
                                <th scope="col" width={400}>
                                DESCRIPTION
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {subcategories.length?subcategories.map((subcategory,index)=>{
                                return(
                                    <tr key={index} >
                                        <td>{subcategory.id}</td>
                                        <td style={{cursor: 'pointer'}} onClick={()=>this.onUpdateSubcategory(subcategory)}>{subcategory && subcategory.name?subcategory.name :""}</td>
                                        <td>{subcategory.description}</td>
                                    </tr>
                                )
                            }):null}
                        </tbody>
                    </table>
                    {!subcategories.length && !loading ? (
                                <div style={{ textAlign: "center" }}>No Data</div>) : null}
                </div>
            </div>
        );
    }
  }
  
  export default withRouter(connect()(withApollo(SubcategoryList)));  